import React from 'react'

export default function RecordNavigatorStyle() {
  return (
    <style jsx='true'>
    {`
      /*TOTAL RECORDS BEGIN------------------*/
      .total-records-container {
        display: flex;
        flex: 2.5;
        padding: 5px 0;
        align-items: center;
      }
      .total-records-container label {
        background-color: transparent;
        font-size: 0.6em;
        padding: 5px 10px;
      }
      .total-records-container .total-records {
        font-size: 0.6em;
        border: transparent 0px;
        background-color: transparent;
        font-weight: bold;
        padding: 5px 10px;
      }
      /*TOTAL RECORDS END------------------*/

      /*RECORDS PER PAGE BEGIN------------------*/
      .records-per-page-container {
        display: flex;
        flex: 2;
        padding: 5px 0;
        align-items: center;
      }
      .records-per-page-container label {
        font-size: 0.6em;
        background-color: transparent;
        padding: 5px 10px;
      }
      .records-per-page-container .records-per-page {
        background-color: transparent;
        font-size: 0.6em;
        border: solid 1px lightblue;
        font-weight: bold;
        padding: 5px 10px;
      }
      .records-per-page-container button {
        font-size: 0.6em;
        color: lightblue;
        background-color: rgba(82, 91, 91);
      }
      .records-per-page-container button:hover {
        color: whitesmoke;
        background-color: rgba(82, 91, 91, 0.9);
      }
      /*RECORDS PERPAGE END------------------*/

      /*RECORD NAVIGATOR BUTTON BEGIN----------------------*/
      .record-navigator-container {
        display: flex;
        flex: 1.5;
        font-size: 0.6em;
        justify-content: flex-end;
        height: 80%;
        margin: auto 0;
      }
      .record-navigator {
        display: flex;
        padding: 5px 10px;
      }
      .record-navigator button {
        width: 40px;
        border: solid 1px whitesmoke;
        color: white;
        font-weight: bold;
        background-color: rgba(33, 33, 33, 0.8);
        padding: 3px;
      }
      .record-navigator button:hover {
        background-color: rgba(33, 33, 33, 0.7);
        /*cursor: pointer;*/
      }
      .record-navigator .btn-nav-prev {
        border-top-left-radius: 30px;
        border-bottom-left-radius: 30px;
      }
      .record-navigator .btn-nav-next {
        border-top-right-radius: 30px;
        border-bottom-right-radius: 30px;
      }
      .record-navigator .page {
        margin-left: 5px;
      }
      .record-navigator .total-page {
        margin-right: 5px;
      }
      /*RECORD NAVIGATOR BUTTON END----------------------*/
    `}
    </style>
  )
}
